module.exports = __webpack_public_path__ + "img/stax-integration.dad7115d.png";